import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="3"
          fill="none"
          viewBox="0 0 11 3"
        >
          <circle cx="0.5" cy="0.5" r="0.5" fill="#fff"></circle>
          <circle cx="2.5" cy="0.5" r="0.5" fill="#fff"></circle>
          <circle cx="4.5" cy="0.5" r="0.5" fill="#fff"></circle>
          <circle cx="6.5" cy="0.5" r="0.5" fill="#fff"></circle>
          <circle cx="8.5" cy="0.5" r="0.5" fill="#fff"></circle>
          <circle cx="10.5" cy="0.5" r="0.5" fill="#fff"></circle>
          <circle cx="0.5" cy="2.5" r="0.5" fill="#fff"></circle>
          <circle cx="2.5" cy="2.5" r="0.5" fill="#fff"></circle>
          <circle cx="4.5" cy="2.5" r="0.5" fill="#fff"></circle>
          <circle cx="6.5" cy="2.5" r="0.5" fill="#fff"></circle>
          <circle cx="8.5" cy="2.5" r="0.5" fill="#fff"></circle>
          <circle cx="10.5" cy="2.5" r="0.5" fill="#fff"></circle>
        </svg>
    );
}